const labels = {
  streetAddress: 'Street address',
}

export default labels
